import React from 'react'

const Telegram = (props) => (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 10.3333L12 5.33325L0 0.333252V4.22242L8.57143 5.33325L0 6.44409V10.3333Z"
        fill="#0D1536"
        fillOpacity="0.4"
      />
    </svg>
  )


export default Telegram
